import type { Board, GeometryElement } from 'jsxgraph';

/**
 * Re-export of JSXGraph Board type.
 */
export type JXGBoard = Board;

/**
 * Re-export of JSXGraph GeometryElement type.
 */
export type JXGElement = GeometryElement;

// =============================================================================
// NARROW TYPED INTERFACES for JSXGraph elements
// These bridge the gap between JSXGraph's incomplete TS definitions and the
// actual runtime API. All unsafe casts are contained in `asJxg*()` accessors.
// =============================================================================

/** JSXGraph point with coordinate accessors. */
export interface JxgPoint extends GeometryElement {
  X(): number;
  Y(): number;
  setPositionDirectly(method: number, coords: [number, number]): this;
}

/** JSXGraph slider with value accessor. */
export interface JxgSlider extends GeometryElement {
  Value(): number;
  setValue(v: number): void;
}

/** JSXGraph curve with length accessor. */
export interface JxgCurve extends GeometryElement {
  Y(x: number): number;
}

/** Cast a GeometryElement to a typed JxgPoint. */
export function asJxgPoint(el: GeometryElement): JxgPoint {
  return el as unknown as JxgPoint;
}

/** Cast a GeometryElement to a typed JxgSlider. */
export function asJxgSlider(el: GeometryElement): JxgSlider {
  return el as unknown as JxgSlider;
}

/**
 * Context required for creating JSXGraph elements.
 */
export interface ElementCreatorContext {
  board: Board;
  container: HTMLElement;
  resolveValue?: (path: string) => number | string | undefined;
  /** Global default precision for numeric labels. Individual label `precision` overrides this. */
  defaultPrecision?: number;
}
